import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { formations } from '../data/mockData'
import { Clock, Users, Award } from 'lucide-react'

const Formations = () => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: '-100px' })

  const handleInscription = (formation) => {
    const message = `Bonjour GENIUS CLUB !%0A%0A*DEMANDE D'INSCRIPTION*%0A%0A*Formation choisie :* ${formation.title}%0A*Catégorie :* ${formation.category}%0A*Niveau :* ${formation.level}%0A*Durée :* ${formation.duration}%0A%0AJe souhaite m'inscrire à cette formation et obtenir plus d'informations.%0A%0A*Mes objectifs :*%0A${formation.objectives.join('%0A• ')}%0A%0A_Ce message a été envoyé via le site web_`;
    
    const whatsappUrl = `https://wa.me/212673737468?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }

  return (
    <section id="formations" className="py-20 bg-white" ref={ref}>
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="section-title">Nos Formations</h2>
          <p className="section-subtitle max-w-3xl mx-auto">
            Des programmes structurés pour tous les âges et tous les niveaux
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {formations.map((formation, i) => (
            <motion.div
              key={formation.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="group relative bg-white rounded-2xl shadow-lg overflow-hidden card-hover"
            >
              <div className="relative h-64 overflow-hidden">
                <motion.img
                  src={formation.image}
                  alt={formation.title}
                  className="w-full h-full object-cover"
                  whileHover={{ scale: 1.15 }}
                  transition={{ duration: 0.5 }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block bg-primary text-white px-3 py-1 rounded-full text-sm font-medium mb-2">
                    {formation.category}
                  </span>
                  <h3 className="text-2xl font-bold text-white">{formation.title}</h3>
                </div>
              </div>

              <div className="p-6">
                <p className="text-gray-600 mb-4 leading-relaxed">{formation.description}</p>
                
                <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
                  <div className="flex items-center gap-1">
                    <Clock className="w-4 h-4 text-primary" />
                    <span>{formation.duration}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Users className="w-4 h-4 text-primary" />
                    <span>{formation.level}</span>
                  </div>
                </div>

                <div className="border-t pt-4 mb-4">
                  <h4 className="font-semibold text-primary mb-2 flex items-center gap-2">
                    <Award className="w-5 h-5" />
                    Objectifs
                  </h4>
                  <ul className="space-y-1">
                    {formation.objectives.map((obj, idx) => (
                      <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                        <span className="text-primary mt-0.5">•</span>
                        <span>{obj}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex items-center justify-between">
                  <button 
                    onClick={() => handleInscription(formation)}
                    className="btn-primary flex items-center gap-2"
                  >
                    <span>📱</span>
                    S'inscrire
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Formations